export { default as Icon, IconColor, IconName } from './icon_DO_NOT_USE';
